<section class="product-properties" id="additionalSpecifications">
  <!-- section title -->
  <div class="product-properties__header">
    <div class="product-properties__title-container">
      <h3 class="product-properties__title">
        {{ 'products.additionalSpecifications' | translate }}
      </h3>
      <p class="product-properties__subtitle">
        {{ 'products.additionalPropertiesSubtitle' | translate }}
      </p>
    </div>

    <!-- toggle button -->
    <pwj-button
      class="product-properties__toggle-button"
      [variant]="showAdditionalProperties ? 'secondary' : 'primary'"
      [icon]="showAdditionalProperties ? 'chevron-up' : 'chevron-down'"
      iconClasses="!m-0"
      type="button"
      [noContentButton]="true"
      (clicked)="toggleAdditionalProperties()"></pwj-button>
  </div>

  <!-- section items -->
  @if (showAdditionalProperties) {
    <div class="product-properties__content">
      @for (property of properties; track $index) {
        @if (
          property.value ||
          property.colorsList ||
          property.sizeList ||
          property.placeList
        ) {
          <pwj-additional-specification-box
            class="property"
            [additionalTitle]="property.title"
            [additionalTitleSuffix]="property?.titleSuffix"
            [heightMax]="!!property.sizeList">
            <!-- color list properties -->
            @if (property.colorsList) {
              @if (property.colorsList.length === 1) {
                <!-- main color & single colors -->
                <p class="property__main-color">
                  <!-- color box -->
                  <span
                    class="color-box"
                    [style]="
                      setColorBoxStyle(property?.colorsList?.[0]?.color)
                    "></span>
                  <!-- color name -->
                  <span class="color-name"
                    >{{ property?.colorsList?.[0]?.name }}
                  </span>
                  @if (property?.colorPercentage) {
                    <!-- color percentage -->
                    <span class="color-percent">
                      {{ property.colorPercentage }}%
                    </span>
                  }
                </p>
              } @else {
                <ul class="property__other-colors">
                  @for (colorsList of property.colorsList; track $index) {
                    <li class="color-item">
                      <!-- color box -->
                      <span
                        class="color-item__box"
                        [style]="setColorBoxStyle(colorsList.color)"></span>
                      <!-- color number -->
                      <span class="color-item__type">
                        {{ property.title | translate }}
                        <span class="color-type-number">
                          {{ $index + 1 }}
                        </span>
                      </span>
                      <!-- color name -->
                      <p class="color-item__value">
                        <span class="color-name">{{ colorsList.name }}</span>
                      </p>
                    </li>
                  }
                </ul>
              }
            } @else if (property.sizeList && !property?.isEmpty) {
              <!-- sizes list -->
              <div>
                @for (size of property.sizeList; track $index) {
                  <ul class="property__size-list">
                    <!-- length -->

                    <li>
                      @if (size.length) {
                        <p>
                          <span class="size-name"
                            >{{ size.length.title | translate }}
                          </span>

                          <span class="size-value">{{
                            size.length?.value
                          }}</span>
                        </p>
                      }

                      @if (size.length_tolerance) {
                        <p>
                          <span class="size-name"
                            >{{ size.length_tolerance.title | translate }}
                          </span>
                          <span class="size-value">{{
                            size.length_tolerance?.value
                          }}</span>
                        </p>
                      }
                    </li>

                    <!-- width -->
                    <li>
                      @if (size.width) {
                        <p>
                          <span class="size-name"
                            >{{ size.width.title | translate }}
                          </span>
                          <span class="size-value">{{
                            size.width?.value
                          }}</span>
                        </p>
                      }

                      @if (size.width_tolerance) {
                        <p>
                          <span class="size-name"
                            >{{ size.width_tolerance.title | translate }}
                          </span>
                          <span class="size-value">{{
                            size.width_tolerance?.value
                          }}</span>
                        </p>
                      }
                    </li>

                    <!-- height -->
                    <li>
                      @if (size.height) {
                        <p>
                          <span class="size-name"
                            >{{ size.height.title | translate }}
                          </span>
                          <span class="size-value">{{
                            size.height?.value
                          }}</span>
                        </p>
                      }

                      @if (size.height_tolerance) {
                        <p>
                          <span class="size-name"
                            >{{ size.height_tolerance.title | translate }}
                          </span>
                          <span class="size-value">{{
                            size.height_tolerance?.value
                          }}</span>
                        </p>
                      }
                    </li>

                    <!-- weight -->
                    <li>
                      @if (size.weight) {
                        <p>
                          <span class="size-name"
                            >{{ size.weight.title | translate }}
                          </span>
                          <span class="size-value">{{
                            size.weight?.value
                          }}</span>
                        </p>
                      }

                      @if (size.weight_tolerance) {
                        <p>
                          <span class="size-name"
                            >{{ size.weight_tolerance.title | translate }}
                          </span>
                          <span class="size-value">{{
                            size.weight_tolerance?.value
                          }}</span>
                        </p>
                      }
                    </li>
                  </ul>
                }
              </div>
            } @else if (property.placeList && property.placeList.length > 0) {
              <ul class="property__place-list">
                @for (place of property.placeList; track place) {
                  <!-- other single properties -->
                  <li class="property-value">
                    <span>{{ place | translateData }}</span>
                  </li>
                }
              </ul>
            } @else {
              <!-- other single properties -->
              <p class="property-value">{{ property.value | translateData }}</p>
            }
          </pwj-additional-specification-box>
        }
      }
    </div>
  }
</section>
